<template>
<div class="flow_wrap raised_item animate_class px-4 py-3 mb-4" :class="{'flow_wrap_active':data.id==activeflow.id }">

<template v-if="data.id==activeflow.id">
	<h4 class="text-primary">{{data.name}} - {{$store.state.languages.lang_phrases.aktif}}</h4>
	<p class="text-primary">{{flowtype}}</p>
	<template v-if="data.start_date && data.end_date">
		<p class="text-primary"><b>{{$store.state.languages.lang_phrases.akis_etkinlik_suresi}}:</b>{{ $filters.momentFormat( data.start_date," Do-MM-YYYY hh:mm")}} - {{ $filters.momentFormat( data.end_date," Do-MM-YYYY hh:mm")}} </p>
	</template>

	<template v-if="data.start_date && !data.end_date">
		<p class="text-primary"><b>{{$store.state.languages.lang_phrases.akis_etkinlik_baslangici}}:</b>{{ $filters.momentFormat( data.start_date," Do-MM-YYYY hh:mm")}}</p>
	</template>

	<template v-if="!data.start_date && data.end_date">
		<p class="text-primary"><b>{{$store.state.languages.lang_phrases.akis_etkinlik_bitisi}}:</b>{{ $filters.momentFormat( data.end_date," Do-MM-YYYY hh:mm")}}</p>
	</template>

	<div class="flex align-items-center justify-content-end ">
		<Button :label="$store.state.languages.lang_phrases.goster"  class="p-button-white"  @click="gotoActiveFlow(data.uuid)"></Button>
	</div>
</template>



<template v-else>
	<h4 class="text-primary">{{data.name}} - {{$store.state.languages.lang_phrases.henuz_aktif_degil}}</h4>
	<p class="text-primary">{{flowtype}}</p>
	<template v-if="data.start_date && data.end_date">
		<p class="text-primary"><b>{{$store.state.languages.lang_phrases.akis_etkinlik_suresi}}:</b>{{ $filters.momentFormat( data.start_date," Do-MM-YYYY hh:mm")}} - {{ $filters.momentFormat( data.end_date," Do-MM-YYYY hh:mm")}} </p>
	</template>

	<template v-if="data.start_date && !data.end_date">
		<p class="text-primary"><b>{{$store.state.languages.lang_phrases.akis_etkinlik_baslangici}}:</b>{{ $filters.momentFormat( data.start_date," Do-MM-YYYY hh:mm")}}</p>
	</template>

	<template v-if="!data.start_date && data.end_date">
		<p class="text-primary"><b>{{$store.state.languages.lang_phrases.akis_etkinlik_bitisi}}:</b>{{ $filters.momentFormat( data.end_date," Do-MM-YYYY hh:mm")}}</p>
	</template>

	<div class="flex align-items-center justify-content-end ">
		<Button :label="$store.state.languages.lang_phrases.goster"  class="p-button-white"  @click="gotoActiveFlow(data.uuid)"></Button>

		<Button label="Aktif akış yap"  class="p-button-white ml-2"  @click="markAsActive" :loading="loading"></Button>
	</div>


</template>



  <Dropdown  v-model="activeflow_status" :options="statuses" optionLabel="name" optionValue="code" class=" p-inputtext-sm" @change="flowsupplierStatusChanged"/>


</div>
</template>

<script>
export default {

  name: 'SupplierProjectFlow',
  props:["data","activeflow"],
  data () {
    return {
    	statuses:[
    	{name:"Oluşturuldu",code:"created"},
    	{name:"Başlandı",code:"started"},
    	{name:"Görüntülendi",code:"viewed"},
    	{name:"Tamamlandı",code:"finished"},
    	{name:"İptal Edildi",code:"canceled"},
    	{name:"Düzeltme Talep Edildi",code:"correction_requested"},
    	{name:"İncelemede",code:"under_review"},
    	],
    	activeflow_status:null,
    	loading:false,
    }
  },
  computed:{
  	flowtype()
  	{
  		if(this.data.type=="self_evaluation")
  		{
  			return this.$store.state.languages.lang_phrases.self_evaluation
  		}

  		if(this.data.type=="education")
  		{
  			return this.$store.state.languages.lang_phrases.egitim
  		}
  		if(this.data.type=="verification")
  		{
  			return this.$store.state.languages.lang_phrases.verification
  		}
  		if(this.data.type=="audit")
  		{
  			return this.$store.state.languages.lang_phrases.denetleme
  		}
  	}
  },
  mounted()
  {
  	this.activeflow_status = this.activeflow.suppliers[0].status
  },
  methods:{
  	gotoActiveFlow(uuid)
  	{
  		console.log(this.data)
  		console.log(this.activeflow.suppliers[0])
  		this.$store.dispatch('evaluation/setMode',"admin_viewing") 
  		this.$router.push({ name: 'EvaluationProgress', params: { id:this.activeflow.suppliers[0].uuid } })
  	},
  	markAsActive()
  	{
  		console.log(this.data.id)
  		return false
  		this.loading = true
  		let formdata = new FormData()
  		formdata.append("activeflow_id",this.data.id)
    	this.generalSubmission(formdata,"audit/update_project_active_flow/"+this.$route.params.project_id,this.aftermarkAsActive)
  	},
  	aftermarkAsActive(response)
  	{
  		console.log(response.data)
  		this.loading = false
  		this.$emit("activeFlowUpdated",response.data)
  	},
  	flowsupplierStatusChanged()
  	{
  		console.log(this.activeflow)
  		console.log(this.data)
  		let formdata = new FormData()
    	formdata.append("flowsupplier_id",this.activeflow.suppliers[0].id)
    	formdata.append("new_status",this.activeflow_status)
    	this.generalSubmission(formdata,"supplier/update_flowsupplier_status/"+this.data.id,this.afterdataChanged)
  	},
  	afterdataChanged(response)
  	{
  		console.log(response.data)
  		//this.activeflow.suppliers[0] = response.data
  	}
  },
}
</script>

<style lang="css" scoped>
</style>